// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { getIabCategoryListFailed, getIabCategoryListRequested, getIabCategoryListSucceeded } from './select-iab-category.actions';
import { IabCategoryService } from '@par/app/shared/select-iab-category/services/iab-category.service';

@Injectable()
export class SelectIabCategoryEffects {

  listRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getIabCategoryListRequested),
      mergeMap(() => this.service.getIabCategories()
        .pipe(
          map((response) => getIabCategoryListSucceeded({response})),
          catchError(() => of(getIabCategoryListFailed())),
        )),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: IabCategoryService,
  ) {
  }
}
